(() => {
  const parseDate = (value) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day ? value : null;
  };
  const japanToday = (now = new Date()) => new Intl.DateTimeFormat('sv-SE', { timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
  const normalize = (items) => items.flatMap((item) => {
    const start = parseDate(item.start.trim());
    const end = item.end.trim() ? parseDate(item.end.trim()) : start;
    return start && end && end >= start && ['open', 'closed'].includes(item.status) ? [{ ...item, start, end }] : [];
  });
  const statusFor = (date, weekdays, exceptions) => {
    const match = [...exceptions].reverse().find((item) => item.start <= date && date <= item.end);
    if (match) return { type: match.status === 'closed' ? 'special-closed' : 'special-open', label: match.status === 'closed' ? '臨時休業' : '臨時営業', note: match.note };
    return weekdays.includes(new Date(`${date}T00:00:00Z`).getUTCDay()) ? { type: 'closed', label: '定休日' } : { type: 'open', label: '営業日' };
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { parseDate, japanToday, normalize, statusFor };
  if (typeof customElements === 'undefined' || customElements.get('dhuni-store-calendar')) return;
  customElements.define('dhuni-store-calendar', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const settings = this.querySelector('[data-calendar-settings]');
      this.weekdays = settings.dataset.weekdays.split(',').filter(Boolean).map(Number);
      const items = [...settings.querySelectorAll('[data-exception]')].map((item) => ({ start: item.dataset.start, end: item.dataset.end, status: item.dataset.status, note: item.dataset.note }));
      this.exceptions = normalize(items);
      if (window.Shopify?.designMode && items.length !== this.exceptions.length) {
        const warning = document.createElement('p');
        warning.textContent = '日付の設定を確認してください。未入力・存在しない日付・開始日より前の終了日はカレンダーに反映されません。形式：YYYY-MM-DD';
        this.append(warning);
      }
      this.today = japanToday();
      const [year, month] = this.today.split('-').map(Number);
      this.month = new Date(Date.UTC(year, month - 1, 1));
      this.querySelector('[data-previous]').addEventListener('click', () => this.move(-1));
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1));
      this.render();
    }
    move(offset) { this.month.setUTCMonth(this.month.getUTCMonth() + offset); this.render(); }
    render() {
      const year = this.month.getUTCFullYear();
      const month = this.month.getUTCMonth();
      this.querySelector('[data-month]').textContent = `${year}年 ${month + 1}月`;
      const table = document.createElement('table');
      table.setAttribute('aria-label', `${year}年${month + 1}月の営業カレンダー`);
      const head = table.createTHead().insertRow();
      [...'日月火水木金土'].forEach((day) => { const th = document.createElement('th'); th.scope = 'col'; th.textContent = day; head.append(th); });
      const body = table.createTBody();
      const last = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
      const first = this.month.getUTCDay();
      const notices = [];
      for (let index = 0; index < Math.ceil((first + last) / 7) * 7; index++) {
        const row = index % 7 === 0 ? body.insertRow() : body.rows[body.rows.length - 1];
        const cell = row.insertCell();
        const day = index - first + 1;
        if (day < 1 || day > last) { cell.setAttribute('aria-hidden', 'true'); continue; }
        const date = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        const status = statusFor(date, this.weekdays, this.exceptions);
        cell.className = `is-${status.type}`;
        const label = `${month + 1}月${day}日 ${status.label}${status.note ? `：${status.note}` : ''}`;
        cell.setAttribute('aria-label', label);
        cell.title = label;
        const number = document.createElement('span'); number.textContent = day;
        const marker = document.createElement('small'); marker.textContent = { open: '○', closed: '休', 'special-closed': '臨', 'special-open': '営' }[status.type];
        cell.append(number, marker);
        if (date === japanToday()) cell.setAttribute('aria-current', 'date');
        if (status.type.startsWith('special-')) { const li = document.createElement('li'); li.textContent = label; notices.push(li); }
      }
      this.querySelector('[data-month-grid]').replaceChildren(table);
      this.querySelector('[data-notices]').replaceChildren(...notices);
    }
  });
})();
